/*
 * @Description: 
 * @Autor: yd
 * @Date: 2020-08-31 13:51:29
 * @LastEditors: yd
 * @LastEditTime: 2020-08-31 13:52:27
 */

export const SASTOKEN = '?sv=2019-12-12&ss=bfqt&srt=co&sp=rwdlacupx&se=2020-09-18T11:56:39Z&st=2020-08-18T03:56:39Z&spr=https,http&sig=T%2FFfmd4JSaxFM%2FdPQGGxggUnBOazPfcUcy9Umit6sdg%3D'